import filter from './filter'
import tagbar from './tag-bar'
import macrotrendView from './macrotrend-view'
import microtrends from './microtrends'
import microtrendView from './microtrend-view'
import megatrendView from './megatrend-view'
import sidebar from './sidebar'

export default {
    filter,
    tagbar,
    macrotrendView,
    megatrendView,
    microtrends,
    microtrendView,
    sidebar
}
